module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 18.0eb84ed6.mp3";